export default __webpack_public_path__ + "static/favicon-196-27a7750879d04d88986dac785a190460.png";